import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UploadFilesPayload {
  images: File[]
}

export interface UploadSellerPaymentConfirmationPayload {
  images: File[]
}

export interface UploadInternationalPaymentReceiptPayload {
  images: File[]
}

export interface UploadIranianPaymentReceiptPayload {
  images: File[]
}

function buildFormData(payload: UploadFilesPayload): FormData {
  const formData = new FormData()

  payload.images.forEach((image, index) => {
    formData.append(`images[${index}]`, image)
  })

  return formData
}

//  Settlement Receipt
export function uploadSettlementReceiptWithoutChangeStatusAction(
  transactionId: string,
  payload: UploadFilesPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/settlement-receipt-without-change-status`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

//  International Payment Receipt
export function uploadInternationalPaymentReceiptWithoutChangeStatusAction(
  transactionId: string,
  payload: UploadFilesPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/international-payment-receipt-without-change-status`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

//  Iranian Payment Receipt
export function uploadIranianPaymentReceiptWithoutChangeStatusAction(
  transactionId: string,
  payload: UploadFilesPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/iranian-payment-receipt-without-change-status`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

export function uploadSellerPaymentConfirmationAction(
  transactionId: string,
  payload: UploadSellerPaymentConfirmationPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/seller-payment-confirmation`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

export function uploadIranianPaymentReceiptAction(
  transactionId: string,
  payload: UploadIranianPaymentReceiptPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/iranian-payment-receipt`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

export function uploadInternationalPaymentReceiptAction(
  transactionId: string,
  payload: UploadInternationalPaymentReceiptPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/international-payment-receipt`
  return api.post<ApiResponse<unknown>>(url, buildFormData(payload))
}

// Register international payment
export function registerInternationalPaymentAction(transactionId: string): Promise<ApiResponse<unknown>> {
  return api.post(`/transactions/${transactionId}/register-international-payment`)
}

export function registerIranianPaymentAction(transactionId: string): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/register-iranian-payment`
  return api.post<ApiResponse<unknown>>(url)
}

export function uploadSettlementReceiptAction(
  transactionId: string,
  payload: UploadIranianPaymentReceiptPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/settlement-receipt`

  const formData = new FormData()

  payload.images.forEach((image, index) => {
    formData.append(`images[${index}]`, image)
  })

  formData.append('formData', 'true')

  return api.post<ApiResponse<unknown>>(url, formData)
}

export interface RegisterSettlementReceiptPayload {
  [key: string]: unknown
  amount: number
  date: string
  status: string
  tracking_id: string
}

export function registerSettlementReceiptAction(
  transactionId: string,
  payload: RegisterSettlementReceiptPayload
): Promise<ApiResponse<unknown>> {
  const url = `/transactions/${transactionId}/register-settlement-receipt`

  return api.post<ApiResponse<unknown>>(url, payload)
}
